import { ordinal } from '../utils/ordinal';
import { DateTime } from 'luxon';

export interface IAppointmentManagementItem {
  displayFullAppt: string;
  itemTime: string;
  petName: string;
  species: string;
  reservationPublicId?: string;
  visitPublicId?: string;
  itemDateTime: string;
}

export class AppointmentManagementItem implements IAppointmentManagementItem {
  displayFullAppt: string;
  itemTime: string;
  petName: string;
  species: string;
  reservationPublicId?: string | undefined;
  visitPublicId?: string | undefined;
  itemDateTime: string;

  constructor(params: Partial<IAppointmentManagementItem> = {}) {
    const {
      itemTime = '',
      petName = '',
      species = '',
      reservationPublicId = undefined,
      visitPublicId = undefined,
    } = params;

    this.petName = petName;
    this.species = species;
    const fullDate = new Date(itemTime);
    this.displayFullAppt = `${DateTime.fromJSDate(fullDate).toFormat('EEEE, MMMM')} ${ordinal.getNumberOrdinal(fullDate.getDate())}`;
    this.itemTime = DateTime.fromJSDate(fullDate).toFormat('h:mma');
    this.reservationPublicId = reservationPublicId;
    this.visitPublicId = visitPublicId;
    this.itemDateTime =
      DateTime.fromJSDate(fullDate).toFormat('MM/dd/yyyy hh:mm a');
  }
}
